/**
 * 이메일을 마스킹하는 함수
 * 앞 2자리와 @ 뒤 도메인 부분을 제외하고 나머지를 *로 마스킹
 * 예: test@test.com -> te**@test.com
 * 예: a@test.com -> a*@test.com (1글자인 경우 뒤에 * 추가)
 * 예: ab@test.com -> ab@test.com (2글자인 경우 마스킹 없음)
 */
export function maskEmail(email: string): string {
  if (!email || !email.includes('@')) {
    return email;
  }

  const [localPart, domain] = email.split('@');
  
  if (localPart.length <= 2) {
    // 로컬 부분이 2글자 이하인 경우
    if (localPart.length === 1) {
      return `${localPart}*@${domain}`;
    } else {
      return `${localPart}@${domain}`;
    }
  } else {
    // 로컬 부분이 3글자 이상인 경우
    const firstTwo = localPart.substring(0, 2);
    const maskedPart = '*'.repeat(localPart.length - 2);
    return `${firstTwo}${maskedPart}@${domain}`;
  }
}

/**
 * 이메일 유효성 검사 함수
 */
export function isValidEmail(email: string): boolean {
  const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
  return emailRegex.test(email);
}
